import {Container, Point} from 'pixi.js';
import {ObjectBuilder, ScreenParameters} from '@gongxigames/framework/core';
import {StickyData} from '@gongxigames/framework/slot/modules/watermark/components/StickyData';
import {StickyTo} from '@gongxigames/framework/core/fragments/react';

export class StickyComponent {

    protected _sourceContainer: Container;
    protected _startPosition: Point;
    protected _initialPosition: Point;
    protected _initialStickyPosition?: StickyTo;

    constructor(protected data: StickyData, objectBuilder: ObjectBuilder, rootContainer: Container) {

        this._sourceContainer = rootContainer.getChildByName<Container>(data.sourceContainerName);
        this._initialPosition = this._sourceContainer.position.clone();
        this._startPosition = this._sourceContainer.position.clone();
        this._initialStickyPosition = this.data.stickyPosition;
        this.initGraphic(data, objectBuilder, rootContainer);
    }

    protected initGraphic(data: StickyData, objectBuilder: ObjectBuilder, rootContainer: Container): void {}

    public resize(screenParams: ScreenParameters, isFullscreen: boolean): void {
        const {stickyPosition} = this.data;

        if (stickyPosition && stickyPosition !== 'none') {
            this._sourceContainer.position = screenParams.getStickyPosition(this._initialPosition, stickyPosition, isFullscreen);
        }
    }

    public hide(): void {
        this._sourceContainer.visible = false;
    }

    public show(): void {
        this._sourceContainer.visible = true;
    }

    public setPosition(value: Point): void {
        this._sourceContainer.position = value;
    }

    public setInitialPosition(value: Point): void {
        this._initialPosition = value;
    }

    public setStickyPosition(value?: StickyTo): void {
        this.data.stickyPosition = value;
    }

    public restoreStartPosition(): void {
        if (this._startPosition) {
            this._initialPosition = this._startPosition;
            this.setPosition(this._startPosition);
        }
    }

    public restoreInitialStickyPosition(): void {
        this.setStickyPosition(this._initialStickyPosition);
    }

    public get initialPosition(): Point|undefined {
        return this._initialPosition;
    }

    public get sourceContainer(): Container {
        return this._sourceContainer;
    }
}
